import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  max-width: 992px;
  margin: 0 auto;
  padding: 0 16px;
`
